import http from './api'

const route = 'app/entrega/'

export default {
  showDadosEntrega: (dataInicial, dataFinal, empresaSelect, tokencontrato, dataInicialStatus, dataFinalStatus, motorista, statusEntrega, selectOpcaoOrdenacao, selectOrientacaoOrdem) => {
    return http.post(route + 'showDadosEntrega', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresas: empresaSelect,
      tokenContrato: tokencontrato,
      dataInicialStatus: dataInicialStatus,
      dataFinalStatus: dataFinalStatus,
      motorista: motorista,
      statusEntrega: statusEntrega,
      selectOpcaoOrdenacao: selectOpcaoOrdenacao,
      selectOrientacaoOrdem: selectOrientacaoOrdem,
    })
  },

  showRankingEntrega: (dataInicial, dataFinal, empresaSelect, tokencontrato) => {
    return http.post(route + 'showRankingEntrega', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresas: empresaSelect,
      tokenContrato: tokencontrato,
    })
  },

  showDadosGraficoEntrega: (dataInicial, dataFinal, empresaSelect, tokencontrato, dataInicialStatus, dataFinalStatus, motorista, statusEntrega) => {
    return http.post(route + 'showDadosGraficoEntrega', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresas: empresaSelect,
      tokenContrato: tokencontrato,
      dataInicialStatus: dataInicialStatus,
      dataFinalStatus: dataFinalStatus,
      motorista: motorista,
      statusEntrega: statusEntrega,
    })
  },

  showDadosMotoristas: (dataInicial, dataFinal, empresaSelect, tokencontrato, dataInicialStatus, dataFinalStatus, motorista, statusEntrega) => {
    return http.post(route + 'showDadosMotoristas', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresas: empresaSelect,
      tokenContrato: tokencontrato,
      dataInicialStatus: dataInicialStatus,
      dataFinalStatus: dataFinalStatus,
      motorista: motorista,
      statusEntrega: statusEntrega,
    })
  },

  showUltimaLocalizacao: (tokencontrato) => {
    return http.post(route + 'showUltimaLocalizacao', {
      tokenContrato: tokencontrato,
    })
  },

  showLocalizacaoMotorista: (tokencontrato, romaneio) => {
    return http.post(route + 'showLocalizacaoMotorista', {
      tokenContrato: tokencontrato,
      romaneio: romaneio,
    })
  },
}
